
(function () {
    'use strict';

    run.admin.pages.avatarCrop = function() {
        $(document).ready(function() {
            const csrf_name = document.getElementsByName('csrf_name')[0].value;
            const csrf_value = document.getElementsByName('csrf_value')[0].value;

            const image = document.getElementById('avatar_crop');
            const saveButton = document.getElementById('save');

            var c = new Croppie(image, {
                viewport: {
                    width: 250,
                    height: 250,
                    type: 'square'
                },
                enableResize: false,
                boundary: { width: 300, height: 300 },
            });

            c.bind({
                url: image.dataset.url
            }).then(function(){ 
                document.getElementById('loading_crop').classList.add('d-none');
            });

            saveButton.addEventListener('click', function(e) {
                $(this).buttonLoadingState('loading');
                c.result({
                    type: 'canvas',
                    size: 'viewport'
                }).then(function(croppieResponse){
                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('image', croppieResponse);

                    axios.post(GlobalRoutes.avatar.cropSave, data)
                        .then(function (response) {
                            if (response.data.status == 'success') {
                                window.location = GlobalRoutes.profile.edit;
                            }
                        })
                        .catch(function (error) {
                            $(this).buttonLoadingState('reset');
                            new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                        });
                });
            });
        });
    };
})();